import React from 'react';
import styles from './ReportSectionSelectList.module.scss';
import { ReportSectionSelectOption } from '../ReportSectionSelect';
import { ReportSectionSelectListOption } from './ReportSectionSelectListOption/ReportSectionSelectListOption';
import { ReportSectionID } from '../../FullReport';

export interface ReportSectionSelectListProps {
  className: string;
  options: ReportSectionSelectOption[];
  selected: string;
  onClick: (incidentNumber: ReportSectionID) => void;
}

export const ReportSectionSelectList = ({
  className,
  options,
  selected,
  onClick
}: ReportSectionSelectListProps): React.ReactElement<ReportSectionSelectListProps> => {
  return (
    <ul
      className={`${styles.reportSectionSelectList} ${className}`}
      role="menu"
    >
      {options.map((option: ReportSectionSelectOption) => (
        <ReportSectionSelectListOption
          key={option.sectionName}
          {...option}
          isSelected={option.sectionId === selected}
          onClick={() => onClick(option.sectionId)}
        />
      ))}
    </ul>
  );
};
